import {Component, ElementRef, Input, Renderer2} from '@angular/core';
export class CarouselSlideComponent {
public src;
public link;
public route;
/**
 * @param {?} el
 * @param {?} renderer
 */
constructor(private el: ElementRef,
private renderer: Renderer2) {
    }
/**
 * @param {?} offset
 * @param {?=} deleyPercent
 * @return {?}
 */
slide(offset, deleyPercent = null) {
        // if (deleyPercent != null) {
        //     this.renderer.setStyle(this.el.nativeElement,
        //         'transition', 'transform 0.' + Math.floor(deleyPercent / 100 * 7) + 's ease-in-out');
        // } else {
            this.renderer.addClass(this.el.nativeElement, 'delay');
        // }
        this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(' + offset + 'px, 0, 0)');
    }
/**
 * @param {?} offset
 * @return {?}
 */
stabilizes(offset) {
        this.renderer.removeClass(this.el.nativeElement, 'delay');
        this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(' + offset + 'px, 0, 0)');
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'pac-carousel-slide',
    template: `
      <ng-container *ngIf="!route ">
          <a [href]="link?link:'#'">
              <img [src]="src" draggable="false">
          </a>
      </ng-container>

      <ng-container *ngIf="route">
          <a [routerLink]="route">
              <img [src]="src" draggable="false">
          </a>
      </ng-container>
      <div class="image-overlay"></div>
    `,
    styles: [`
      :host {
        min-width: 100%;
        width: 100%;
        height: 100%;
        display: inline-table;
        overflow: hidden;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        text-transform: uppercase;
        position: relative;
        cursor: pointer;
        -ms-flex-align: end;
        -webkit-box-align: end;
                align-items: flex-end;
        -ms-flex-line-pack: end;
        align-content: flex-end; }
        :host.delay {
          -webkit-transition: transform .7s ease-in-out;
          -webkit-transition: -webkit-transform .7s ease-in-out;
          transition: -webkit-transform .7s ease-in-out;
          transition: transform .7s ease-in-out;
          transition: transform .7s ease-in-out, -webkit-transform .7s ease-in-out; }
        :host img {
          width: 100%; }
        :host .image-overlay {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'src': [{ type: Input },],
'link': [{ type: Input },],
'route': [{ type: Input },],
};
}

function CarouselSlideComponent_tsickle_Closure_declarations() {
/** @type {?} */
CarouselSlideComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CarouselSlideComponent.ctorParameters;
/** @type {?} */
CarouselSlideComponent.propDecorators;
/** @type {?} */
CarouselSlideComponent.prototype.src;
/** @type {?} */
CarouselSlideComponent.prototype.link;
/** @type {?} */
CarouselSlideComponent.prototype.route;
/** @type {?} */
CarouselSlideComponent.prototype.el;
/** @type {?} */
CarouselSlideComponent.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
